import { MRT_Localization_FR as fr_FR } from 'material-react-table/locales/fr';
import { MRT_Localization_IT as it_IT } from 'material-react-table/locales/it';
import { MRT_Localization_ES as es_ES } from 'material-react-table/locales/es';
import { MRT_Localization_EN as en_GB } from 'material-react-table/locales/en';
import { MRT_Localization_DE as de_DE } from 'material-react-table/locales/de';
import { MRT_Localization_NL as nl_NL } from 'material-react-table/locales/nl';
import { MRT_Localization_PT as pt_PT } from 'material-react-table/locales/pt';

export const MRTLocale = {
    fr_FR,
    it_IT,
    es_ES,
    en_GB,
    de_DE,
    nl_NL,
    pt_PT
};
